export const PORTRAIT_COUNT = 39;

export function portraitUrl(index: number): string {
  return `/images/portraits/selfie_${index}.png`;
}

export async function fetchPortraitFile(index: number): Promise<File | null> {
  const name = `selfie_${index}.png`;
  try {
    const res = await fetch(portraitUrl(index));
    if (!res.ok) return null;
    const blob = await res.blob();
    return new File([blob], name, { type: blob.type || 'image/png' });
  } catch {
    return null;
  }
}

export async function fetchRandomPortraitFile(): Promise<File | null> {
  const idx = Math.floor(Math.random() * PORTRAIT_COUNT);
  return fetchPortraitFile(idx);
}

let modalEl: HTMLElement | null = null;
let currentResolve: ((file: File | null) => void) | null = null;

type PickHandler = (file: File) => void;

export async function openPortraitPicker(onPick: PickHandler): Promise<void> {
  ensureModal();
  if (!modalEl) return;
  modalEl.classList.remove('hidden');

  const file = await new Promise<File | null>((resolve) => {
    currentResolve = resolve;
  });

  if (file) onPick(file);
}

function ensureModal(): void {
  if (modalEl) return;

  modalEl = document.createElement('div');
  modalEl.className = 'portrait-picker-modal hidden';

  const thumbs = Array.from({ length: PORTRAIT_COUNT }, (_, i) => {
    return `
      <button type="button" class="portrait-thumb" data-portrait-index="${i}">
        <img src="${portraitUrl(i)}" alt="Portrait ${i + 1}" loading="lazy"/>
      </button>
    `;
  }).join('');

  modalEl.innerHTML = `
    <div class="portrait-picker-dialog">
      <div class="portrait-picker-header">
        <span>Choose Portrait</span>
        <button type="button" class="portrait-picker-close" aria-label="Close">×</button>
      </div>
      <div class="portrait-picker-grid">${thumbs}</div>
    </div>
  `;
  document.body.appendChild(modalEl);

  const close = (): void => closeModal(null);
  modalEl.querySelector('.portrait-picker-close')?.addEventListener('click', close);
  modalEl.addEventListener('click', (e) => {
    if (e.target === modalEl) close();
  });
  document.addEventListener('keydown', (e) => {
    if (modalEl?.classList.contains('hidden')) return;
    if (e.key === 'Escape') close();
  });

  modalEl.querySelector('.portrait-picker-grid')?.addEventListener('click', async (e) => {
    const target = e.target;
    if (!(target instanceof Element)) return;
    const btn = target.closest<HTMLElement>('[data-portrait-index]');
    if (!btn) return;
    const idx = Number(btn.dataset.portraitIndex);
    const file = await fetchPortraitFile(idx);
    closeModal(file);
  });
}

function closeModal(file: File | null): void {
  modalEl?.classList.add('hidden');
  if (currentResolve) {
    currentResolve(file);
    currentResolve = null;
  }
}
